import queryString from 'query-string'
import { UserAPI } from './types'
import { filterQueryParams } from '@/utils'

export const userApi: UserAPI = ky => {
  return {
    async fetch() {
      return await ky('me/', {
        method: 'get'
      }).json()
    },

    async changePassword({ password, currentPassword }) {
      return await ky('me/', {
        method: 'patch',
        body: JSON.stringify({ password, currentPassword })
      }).json()
    },

    async worker({ workerId }) {
      return await ky(`worker/${workerId}/`, {
        method: 'get'
      }).json()
    },

    async patient({ patientId }) {
      return await ky(`patient/${patientId}/`, {
        method: 'get'
      }).json()
    },

    async patientList({ page, query, scope, archived, active }) {
      return await ky('patient/', {
        method: 'get',
        searchParams: queryString.stringify({
          query,
          page,
          scope,
          archived,
          active
        })
      }).json()
    },

    async workerList({ patientIds, page, query, occupation, scope }) {
      return await ky('worker/', {
        method: 'get',
        searchParams: queryString.stringify({
          patientId: patientIds,
          ...filterQueryParams({
            page,
            query,
            occupation,
            scope
          })
        })
      }).json()
    },

    async occupationList() {
      return await ky('occupation/', {
        method: 'get'
      }).json()
    },

    async patchMe({ params }) {
      return await ky('me/', {
        method: 'patch',
        body: JSON.stringify(params)
      }).json()
    },

    async patchWorker({ workerId, params }) {
      return await ky(`worker/${workerId}/`, {
        method: 'patch',
        body: JSON.stringify(params)
      }).json()
    },

    async privateWorker() {
      return await ky('me/worker/', {
        method: 'get'
      }).json()
    },

    async patchPrivateWorker({ params }) {
      return await ky('me/worker/', {
        method: 'patch',
        body: JSON.stringify(params)
      }).json()
    },

    async createPatient({ params }) {
      return await ky('patient/', {
        method: 'post',
        body: JSON.stringify(params)
      }).json()
    },

    async patchPatient({ params, patientId }) {
      return await ky(`patient/${patientId}/`, {
        method: 'patch',
        body: JSON.stringify(params)
      }).json()
    },

    async sendMailToPatient({ patientId }) {
      return await ky(`patient/${patientId}/send_email/`, {
        method: 'post',
        body: JSON.stringify({})
      }).json()
    },

    async sendMailToRelative({ relativeId }) {
      return await ky(`patient_relative/${relativeId}/send_email/`, {
        method: 'post',
        body: JSON.stringify({})
      }).json()
    },

    async fetchPatientRegistration({ patientId }) {
      return await ky(`patient/${patientId}/registration/`, {
        method: 'get'
      }).json()
    },

    async privatePatient() {
      return await ky('me/patient/', {
        method: 'get'
      }).json()
    },

    async patchPrivatePatient({ params }) {
      return await ky('me/patient/', {
        method: 'patch',
        body: JSON.stringify(params)
      }).json()
    },

    async privateRelative() {
      return await ky('me/relative/', {
        method: 'get'
      }).json()
    },

    async patchPrivateRelative({ params }) {
      return await ky('me/relative/', {
        method: 'patch',
        body: JSON.stringify(params)
      }).json()
    },

    async relativeList() {
      return ky(`patient_relative/`, {
        method: 'get'
      }).json()
    },

    async relative({ relativeId }) {
      return ky(`patient_relative/${relativeId}/`, {
        method: 'get'
      }).json()
    },

    async createRelative(payload) {
      return await ky(`patient_relative/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    },

    async patchRelative({ relativeId, payload }) {
      return await ky(`patient_relative/${relativeId}/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    },

    async deleteRelative({ relativeId }) {
      await ky(`patient_relative/${relativeId}/`, {
        method: 'delete'
      })
    },

    async fetchRelativeRegistration({ relativeId }) {
      return await ky(`patient_relative/${relativeId}/registration/`, {
        method: 'get'
      }).json()
    }
  }
}
